import { render, staticRenderFns } from "./JgpLayoutBorder.vue?vue&type=template&id=fea5c3cc&"
import script from "./JgpLayoutBorder.vue?vue&type=script&lang=js&"
export * from "./JgpLayoutBorder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports